/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_S4Inputs */

const en_tut_fokus_s4 = /** @type {(inputs: Tut_Fokus_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To show the state of the work, press **Buat papan status baru**, choose a **Sumber status** you are allowed to see, and pick its shape: **Lampu status**, **Kotak antrean**, or **Monitor**.`)
};

const id_tut_fokus_s4 = /** @type {(inputs: Tut_Fokus_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk menampilkan kondisi pekerjaan, tekan **Buat papan status baru**, pilih **Sumber status** yang boleh Anda akses, lalu bentuk tampilannya: **Lampu status**, **Kotak antrean**, atau **Monitor**.`)
};

/**
* | output |
* | --- |
* | "To show the state of the work, press **Buat papan status baru**, choose a **Sumber status** you are allowed to see, and pick its shape: **Lampu status**, **K..." |
*
* @param {Tut_Fokus_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_s4 = /** @type {((inputs?: Tut_Fokus_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_s4(inputs)
	return en_tut_fokus_s4(inputs)
});